// Pure geometry for table vertical clipping. `height` stays content-derived
// (mutator-owned); `displayHeight` is the OPTIONAL user-shrunk height —
// absent/null means no clipping. Constants MUST match Canvas.jsx (source of
// truth: the module constants near the top of Canvas.jsx).
export const TABLE_HEADER_HEIGHT = 40;
export const TABLE_ROW_HEIGHT = 36;
export const HEADER_BODY_MARGIN = 4;
export const TABLE_BORDER_RADIUS = 4; // verified against Canvas.jsx line 221

export function heightForRows(n) {
    return TABLE_HEADER_HEIGHT + HEADER_BODY_MARGIN + n * TABLE_ROW_HEIGHT + TABLE_BORDER_RADIUS + 1;
}

export function getTableEffectiveHeight(element) {
    if (!element) return 0;
    if (element.type !== 'table' || element.displayHeight == null) {
        return element.height ?? 0;
    }
    const min = heightForRows(1);
    return Math.min(Math.max(element.displayHeight, min), element.height ?? min);
}

export function getVisibleColumnsCount(element, totalColumns) {
    if (element?.type !== 'table' || element.displayHeight == null) return totalColumns;
    const effective = getTableEffectiveHeight(element);
    const rows = Math.floor(
        (effective - TABLE_HEADER_HEIGHT - HEADER_BODY_MARGIN - TABLE_BORDER_RADIUS - 1) / TABLE_ROW_HEIGHT
    );
    return Math.min(Math.max(rows, 1), totalColumns);
}

export function snapTableDisplayHeight(rawHeight, element, totalColumns) {
    const rows = Math.round(
        (rawHeight - TABLE_HEADER_HEIGHT - HEADER_BODY_MARGIN - TABLE_BORDER_RADIUS - 1) / TABLE_ROW_HEIGHT
    );
    const clamped = Math.min(Math.max(rows, 1), totalColumns);
    if (clamped >= totalColumns) return null; // reached natural height — expand
    return heightForRows(clamped);
}

export function isTableClipped(element, totalColumns) {
    return getVisibleColumnsCount(element, totalColumns) < totalColumns;
}
